/**
 *  @class
 *  @function BackgroundVideo
 */
if (!customElements.get('background-video')) {
	class BackgroundVideo extends HTMLElement {
	  constructor() {
		super();
	  }
  
	  connectedCallback() {
		// Initialize video functionality
		const videoContainer = this.querySelector('.background-video__iframe');
		if (videoContainer && videoContainer.querySelector('iframe')) {
		  videoContainer.querySelector('iframe').onload = () => {
			this.videoPlay(videoContainer);
		  };
		}
  
		// Initialize animations if enabled
		if (document.body.classList.contains('animations-true') && typeof gsap !== 'undefined') {
		  // Ensure content is visible immediately
		  this.querySelector('.background-video__content').style.visibility = 'visible';
		  this.querySelector('.background-video__content').style.opacity = '1';
		  
		  document.fonts.ready.then(() => {
			this.initializeAnimations();
		  });
		}
	  }
  
	  videoPlay(videoContainer) {
		setTimeout(() => {
		  const message = videoContainer.dataset.provider === 'youtube'
			? { event: "command", func: "playVideo", args: "" }
			: { method: "play" };
		  
		  videoContainer.querySelector('iframe').contentWindow.postMessage(
			JSON.stringify(message),
			"*"
		  );
		}, 10);
	  }
  
	  initializeAnimations() {
		const section = this;
		
		// Ensure content wrapper is visible
		gsap.set(section.querySelector('.background-video__content'), {
		  autoAlpha: 1,
		  clearProps: "transform"
		});
  
		// Only split text if elements exist
		const textElements = section.querySelectorAll('h3, p');
		if (textElements.length > 0) {
		  new SplitText(textElements, {
			type: 'lines',
			linesClass: 'line-child'
		  });
		}
  
		const timeline = gsap.timeline({
		  scrollTrigger: {
			trigger: section,
			start: "top 80%",
			toggleActions: "play none none none"
		  }
		});
  
		// Simplified animation sequence
		const contentElements = section.querySelectorAll('.line-child');
		if (contentElements.length > 0) {
		  timeline.from(contentElements, {
			duration: 0.5,
			y: 20,
			autoAlpha: 0,
			stagger: 0.1,
			ease: "power2.out",
			clearProps: "all"
		  });
		}
  
		// Button animation
		const button = section.querySelector('.video-lightbox-modal__button');
		if (button) {
		  timeline.from(button, {
			duration: 0.3,
			autoAlpha: 0,
			y: 10,
			ease: "power2.out",
			clearProps: "all"
		  }, "-=0.2");
		}
	  }
	}
  
	customElements.define('background-video', BackgroundVideo);
  }